
export default {
    data() {
        return {
            menus: [
                {
                    image: '/timer.png',
                    text: 'convenienceAndAccessibility',
                },
                {
                    image: '/click.png',
                    text: 'enhancedUserExperience',
                },
                {
                    image: '/bell.png',
                    text: 'pushNotificationAndExclusiveOfficer',
                },
                {
                    image: '/defence.png',
                    text: 'higherSecurity',
                },
            ],
            downloadButtons: [
                {
                    icon: 'mdi-android',
                    text: 'Android',
                    path: '/download/android',
                },
                {
                    icon: 'mdi-apple',
                    text: 'IOS',
                    path: '/download/ios',
                },
            ],
        }
    },

    methods: {
        naviagetTo(path) {
            this.$router.push(path)
        },
    },
}
